const CalculateScoreColor = (score) => {
  if (score >= 82) {
    return {
      color: '#139306',
      value: 'Clean',
    };
  }

  if (score >= 76) {
    return {
      color: '#86ce00',
      value: 'Good',
    };
  }

  if (score >= 68) {
    return {
      color: '#f3dd2e',
      value: 'Fair',
    };
  }

  if (score >= 55) {
    return {
      color: '#e86902',
      value: 'Poor',
    };
  }
  return {
    color: '#d70a00',
    value: 'Poor',
  };
};

export default CalculateScoreColor;
